/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1DevicePacks, getTKT1NetworkModems, getTKT1PCInfos, createTKT1DevicePack, updateTKT1DevicePack } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';
import Select from 'react-select';

class TKT1DevicePack extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'location_id',
    sortOrder: 1,
    search: '',
    status: ''
  }

  initShowColumns = {
    SN: true,
    NetworkSN: true,
    PCSN: true,
    location_id: true,
    description: true,
    status: true,
    pc_operating_system: true,
    pc_install_date: true,
    pc_anydesk_id: true,
    pc_anydesk_password: true,
    note: false,
    is_deleted: false,
    created_at: false,
    updated_at: false,
    ref_etsy_info_pack_mid: true
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      showEditModal: false,
      showViewModal: false,
      showAddModal: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedDevicePack: null,
      isEditMode: false,
      networkModems: [],
      pcInfos: [],
      newDevicePack: {
        NetworkSN: '',
        PCSN: '',
        location_id: '',
        description: '',
        status: 'AVAILABLE',
        note: ''
      },
      loadingDropdowns: false,
      showNetworkModal: false,
      showPCModal: false,
      selectedNetworkInfo: null,
      selectedPCInfo: null,
      editFormData: {
        NetworkSN: '',
        PCSN: '',
        location_id: '',
        description: '',
        status: 'AVAILABLE',
        note: ''
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Device Pack';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1DevicePack_ViewConfig'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1DevicePacks(apiQuery);
        
        // Load Network Modems and PC Infos for dropdowns
        this.props.getTKT1NetworkModems({ currentPage: 1, itemsPerPage: 1000 });
        this.props.getTKT1PCInfos({ currentPage: 1, itemsPerPage: 1000 });
      })
    } else {
      // No URL params - use localStorage
      var query = JSON.parse(localStorage.getItem('tkt1_device_pack_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1DevicePack_ViewConfig'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1DevicePacks(apiQuery);
          
          // Load Network Modems and PC Infos for dropdowns
          this.props.getTKT1NetworkModems({ currentPage: 1, itemsPerPage: 1000 });
          this.props.getTKT1PCInfos({ currentPage: 1, itemsPerPage: 1000 });
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1DevicePacks(apiQuery);
          
          // Load Network Modems and PC Infos for dropdowns
          this.props.getTKT1NetworkModems({ currentPage: 1, itemsPerPage: 1000 });
          this.props.getTKT1PCInfos({ currentPage: 1, itemsPerPage: 1000 });
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Check if dropdown data has loaded
    if (this.state.loadingDropdowns && 
        this.props.networkModems && this.props.networkModems.length > 0 &&
        this.props.pcInfos && this.props.pcInfos.length > 0) {
      this.setState({ loadingDropdowns: false });
    }
  }

  componentWillReceiveProps(props) {
    // No need to update state since we're using props directly
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_device_pack_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      status: this.state.query.status
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1DevicePacks(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_device_pack_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      status: this.state.query.status
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1DevicePacks(apiQuery);
  }

  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_device_pack_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      status: newQuery.status
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1DevicePacks(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config separately - not related to query
      localStorage.setItem('TKT1DevicePack_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'AVAILABLE':
        return 'Có sẵn';
      case 'IN USE':
        return 'Đang sử dụng';
      case 'CANCEL':
        return 'Hủy';
      case 'ACTIVE':
        return 'Hoạt động';
      case 'INACTIVE':
        return 'Không hoạt động';
      case 'NOT WORKING':
        return 'Không hoạt động';
      default:
        return status;
    }
  }

  // Map provider to Vietnamese
  mapProvider = (provider) => {
    if (!provider) return '-';
    switch (provider.toUpperCase()) {
      case 'FPT':
        return 'FPT';
      case 'VIETTEL':
        return 'Viettel';
      case 'VNPT':
        return 'VNPT';
      default:
        return provider;
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Modal handlers
  handleViewClick = (devicePack) => {
    this.setState({
      showViewModal: true,
      selectedDevicePack: devicePack,
      isEditMode: false
    });
  }

  handleEditClick = (devicePack) => {
    this.setState({
      showEditModal: true,
      selectedDevicePack: devicePack,
      isEditMode: true,
      editFormData: {
        NetworkSN: devicePack.NetworkSN || '',
        PCSN: devicePack.PCSN || '',
        location_id: devicePack.location_id || '',
        description: devicePack.description || '',
        status: devicePack.status || 'AVAILABLE',
        note: devicePack.note || ''
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedDevicePack: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedDevicePack: null,
      isEditMode: false,
      editFormData: {
        NetworkSN: '',
        PCSN: '',
        location_id: '',
        description: '',
        status: 'AVAILABLE',
        note: ''
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleSaveEdit = async () => {
    const { selectedDevicePack, editFormData } = this.state;
    
    if (!selectedDevicePack || !selectedDevicePack._id) {
      alert('Không tìm thấy thông tin Device Pack để cập nhật');
      return;
    }

    try {
      // Call update action
      await this.props.updateTKT1DevicePack(selectedDevicePack._id, editFormData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1DevicePacks(apiQuery);
      
      alert('Cập nhật thông tin Device Pack thành công!');
    } catch (error) {
      console.error('Error updating device pack:', error);
      alert('Lỗi khi cập nhật thông tin Device Pack. Vui lòng thử lại.');
    }
  }

  // Add Modal handlers
  handleAddClick = () => {
    this.setState({
      showAddModal: true,
      loadingDropdowns: true,
      newDevicePack: {
        NetworkSN: '',
        PCSN: '',
        location_id: '',
        description: '',
        status: 'AVAILABLE',
        note: ''
      }
    });
    
    // Load fresh data for dropdowns
    this.props.getTKT1NetworkModems({ currentPage: 1, itemsPerPage: 1000 });
    this.props.getTKT1PCInfos({ currentPage: 1, itemsPerPage: 1000 });
  }

  handleCloseAddModal = () => {
    this.setState({
      showAddModal: false,
      newDevicePack: {
        NetworkSN: '',
        PCSN: '',
        location_id: '',
        description: '',
        status: 'AVAILABLE',
        note: ''
      }
    });
  }

  handleAddInputChange = (field, value) => {
    this.setState({
      newDevicePack: {
        ...this.state.newDevicePack,
        [field]: value
      }
    });
  }

  handleSaveAdd = async () => {
    const { newDevicePack } = this.state;
    
    // Validate required fields
    if (!newDevicePack.NetworkSN || !newDevicePack.PCSN) {
      alert('Vui lòng chọn Network SN và PC SN');
      return;
    }

    try {
      // Call create action
      await this.props.createTKT1DevicePack(newDevicePack);
      
      // Close modal and reset form
      this.handleCloseAddModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1DevicePacks(apiQuery);
      
      alert('Tạo Device Pack thành công!');
    } catch (error) {
      console.error('Error creating device pack:', error);
      alert('Lỗi khi tạo Device Pack. Vui lòng thử lại.');
    }
  }

  // Network and PC modal handlers
  handleNetworkClick = (networkInfo) => {
    this.setState({
      showNetworkModal: true,
      selectedNetworkInfo: networkInfo
    });
  }

  handlePCClick = (pcInfo) => {
    this.setState({
      showPCModal: true,
      selectedPCInfo: pcInfo
    });
  }

  handleCloseNetworkModal = () => {
    this.setState({
      showNetworkModal: false,
      selectedNetworkInfo: null
    });
  }

  handleClosePCModal = () => {
    this.setState({
      showPCModal: false,
      selectedPCInfo: null
    });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Etsy Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, search, status, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim(),
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1DevicePacks(apiQuery);
      localStorage.setItem('tkt1_device_pack_query', JSON.stringify(trimmedQuery));
    })
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1-device/device-pack',
      search: queryStr,
    });
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    // Trim search value before sending to API
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery)
    this.props.getTKT1DevicePacks(apiQuery);
    localStorage.setItem('tkt1_device_pack_query', JSON.stringify(trimmedQuery));
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim(),
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ devicePacks: [] }, () => {
        this.updateUrl(trimmedQuery)
        this.props.getTKT1DevicePacks(apiQuery);
        localStorage.setItem('tkt1_device_pack_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="4">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo SN, NetworkSN, PCSN..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="AVAILABLE">Có sẵn</option>
              <option value="IN USE">Đang sử dụng</option>
              <option value="NOT WORKING">Không hoạt động</option>
              <option value="CANCEL">Hủy</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="location_id">Location ID</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="SN">Serial Number</option>
              <option value="NetworkSN">Network SN</option>
              <option value="PCSN">PC SN</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderDevicePackTable = () => {
    const { devicePacks } = this.props;
    const { showColumns } = this.state;
    
    // Ensure devicePacks is an array and filter out any null/undefined items
    const safeDevicePacks = Array.isArray(devicePacks) ? devicePacks.filter(pack => pack != null && typeof pack === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeDevicePacks || safeDevicePacks.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.location_id && <th>Location ID</th>}
              {showColumns.SN && <th>Serial Number</th>}
              {showColumns.NetworkSN && <th>Network SN</th>}
              {showColumns.PCSN && <th>PC SN</th>}
              {showColumns.description && <th>Mô tả</th>}
              {showColumns.status && <th>Trạng thái</th>}
              {showColumns.pc_operating_system && <th>Hệ điều hành</th>}
              {showColumns.pc_install_date && <th>Ngày cài</th>}
              {showColumns.pc_anydesk_id && <th>AnyDesk ID</th>}
              {showColumns.pc_anydesk_password && <th>AnyDesk Password</th>}
              {showColumns.note && <th>Ghi chú</th>}
              {showColumns.is_deleted && <th>Đã xóa</th>}
              {showColumns.created_at && <th>Ngày tạo</th>}
              {showColumns.updated_at && <th>Ngày cập nhật</th>}
              {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.location_id && <th>Location ID</th>}
            {showColumns.SN && <th>Serial Number</th>}
            {showColumns.NetworkSN && <th>Network SN</th>}
            {showColumns.PCSN && <th>PC SN</th>}
            {showColumns.description && <th>Mô tả</th>}
            {showColumns.status && <th>Trạng thái</th>}
            {showColumns.pc_operating_system && <th>Hệ điều hành</th>}
            {showColumns.pc_install_date && <th>Ngày cài</th>}
            {showColumns.pc_anydesk_id && <th>AnyDesk ID</th>}
            {showColumns.pc_anydesk_password && <th>AnyDesk Password</th>}
            {showColumns.note && <th>Ghi chú</th>}
            {showColumns.is_deleted && <th>Đã xóa</th>}
            {showColumns.created_at && <th>Ngày tạo</th>}
            {showColumns.updated_at && <th>Ngày cập nhật</th>}
            {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
            <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeDevicePacks.map((pack, index) => {
            if (!pack || typeof pack !== 'object') return null;
              
              return (
                <tr key={pack._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.location_id && (
                    <td>{pack.location_id || '-'}</td>
                  )}
                  {showColumns.SN && (
                    <td>
                      {pack.SN ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{pack.SN}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(pack.SN)}
                            title="Copy Serial Number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.NetworkSN && (
                    <td>
                      {pack.NetworkSN ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="primary" 
                            style={{ fontSize: '0.8em', padding: '4px 8px', cursor: 'pointer' }} 
                            onClick={() => pack.network_modem_info && this.handleNetworkClick(pack.network_modem_info)}
                            title="Click để xem thông tin Network"
                          >
                            {pack.NetworkSN}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(pack.NetworkSN)}
                            title="Copy Network SN"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.PCSN && (
                    <td>
                      {pack.PCSN ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="success" 
                            style={{ fontSize: '0.8em', padding: '4px 8px', cursor: 'pointer' }} 
                            onClick={() => pack.pc_info && this.handlePCClick(pack.pc_info)}
                            title="Click để xem thông tin PC"
                          >
                            {pack.PCSN}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(pack.PCSN)}
                            title="Copy PC SN"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.description && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={pack.description}>
                        {pack.description || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      {pack.status ? (
                        <Badge 
                          bg={
                            pack.status === 'AVAILABLE' ? 'success' :
                            pack.status === 'IN USE' ? 'warning' :
                            pack.status === 'NOT WORKING' ? 'danger' :
                            pack.status === 'CANCEL' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(pack.status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.pc_operating_system && (
                    <td>
                      {pack.pc_info && pack.pc_info.operating_system ? (
                        <Badge bg="primary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          {pack.pc_info.operating_system}{pack.pc_info.version ? ` - ${pack.pc_info.version}` : ''}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.pc_install_date && (
                    <td>
                      {pack.pc_info && pack.pc_info.install_date ? 
                        new Date(pack.pc_info.install_date).toLocaleString('vi-VN', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.pc_anydesk_id && (
                    <td>
                      {pack.pc_info && pack.pc_info.anydesk_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>{pack.pc_info.anydesk_id}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(pack.pc_info.anydesk_id)}
                            title="Copy AnyDesk ID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.pc_anydesk_password && (
                    <td>
                      {pack.pc_info && pack.pc_info.anydesk_password ? (
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ whiteSpace: 'nowrap' }} 
                               title={pack.pc_info.anydesk_password}>
                            {pack.pc_info.anydesk_password}
                          </div>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(pack.pc_info.anydesk_password)}
                            title="Copy AnyDesk Password"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={pack.note}>
                        {pack.note || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.is_deleted && (
                    <td>
                      <Badge bg={pack.is_deleted ? "danger" : "success"}>
                        {pack.is_deleted ? "Đã xóa" : "Hoạt động"}
                      </Badge>
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>
                      {pack.created_at ? new Date(pack.created_at).toLocaleString('vi-VN', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                      }) : '-'}
                    </td>
                  )}
                  {showColumns.updated_at && (
                    <td>
                      {pack.updated_at ? new Date(pack.updated_at).toLocaleString('vi-VN', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                      }) : '-'}
                    </td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {pack.ref_etsy_info_pack_mid ? (
                        <Badge 
                          bg="success" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => this.handleEtsyInfoPackClick(pack.ref_etsy_info_pack_mid)}
                          title="Click để xem chi tiết Etsy Info Pack"
                        >
                          {pack.ref_etsy_info_pack_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(pack)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(pack)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Device Pack
              </h2>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="success" 
                  size="sm"
                  className="me-2"
                  onClick={this.handleAddClick}
                >
                  <i className="fas fa-plus"></i> Add Device Pack
                </Button>
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.renderDevicePackTable()}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    SN: 'Serial Number',
                    NetworkSN: 'Network SN',
                    PCSN: 'PC SN',
                    location_id: 'Location ID',
                    description: 'Mô tả',
                    status: 'Trạng thái',
                    pc_operating_system: 'Hệ điều hành',
                    pc_install_date: 'Ngày cài',
                    pc_anydesk_id: 'AnyDesk ID',
                    pc_anydesk_password: 'AnyDesk Password',
                    note: 'Ghi chú',
                    is_deleted: 'Đã xóa',
                    created_at: 'Ngày tạo',
                    updated_at: 'Ngày cập nhật',
                    ref_etsy_info_pack_mid: 'MID Etsy Info Pack'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Device Pack</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedDevicePack && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Serial Number:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedDevicePack.SN}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Location ID:</strong> 
                    <div className="mt-1">{this.state.selectedDevicePack.location_id || '-'}</div>
                  </Col>
                </Row>
                
                {/* Device Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin thiết bị</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Network SN:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                        {this.state.selectedDevicePack.NetworkSN || '-'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>PC SN:</strong> 
                    <div className="mt-1">
                      <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                        {this.state.selectedDevicePack.PCSN || '-'}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedDevicePack.status ? (
                        <Badge 
                          bg={
                            this.state.selectedDevicePack.status === 'AVAILABLE' ? 'success' :
                            this.state.selectedDevicePack.status === 'IN USE' ? 'warning' :
                            this.state.selectedDevicePack.status === 'NOT WORKING' ? 'danger' :
                            this.state.selectedDevicePack.status === 'CANCEL' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedDevicePack.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Đã xóa:</strong> 
                    <div className="mt-1">
                      <Badge bg={this.state.selectedDevicePack.is_deleted ? "danger" : "success"}>
                        {this.state.selectedDevicePack.is_deleted ? "Đã xóa" : "Hoạt động"}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                
                {/* Additional Information */}
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Mô tả:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedDevicePack.description || '-'}
                    </div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedDevicePack.note || '-'}
                    </div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày tạo:</strong> 
                    <div className="mt-1">
                      {this.state.selectedDevicePack.created_at ? 
                        new Date(this.state.selectedDevicePack.created_at).toLocaleString('vi-VN', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày cập nhật:</strong> 
                    <div className="mt-1">
                      {this.state.selectedDevicePack.updated_at ? 
                        new Date(this.state.selectedDevicePack.updated_at).toLocaleString('vi-VN', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Device Pack</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Network SN <span className="text-danger">*</span></Form.Label>
                    <Select
                      value={this.props.networkModems ? this.props.networkModems.find(modem => modem.SN === this.state.editFormData.NetworkSN) ? {
                        value: this.state.editFormData.NetworkSN,
                        label: `${this.state.editFormData.NetworkSN} - ${this.props.networkModems.find(modem => modem.SN === this.state.editFormData.NetworkSN)?.location_id || 'No Location'}`
                      } : null : null}
                      onChange={(selectedOption) => this.handleEditInputChange('NetworkSN', selectedOption ? selectedOption.value : '')}
                      options={this.props.networkModems ? this.props.networkModems.map(modem => ({
                        value: modem.SN,
                        label: `${modem.SN} - ${modem.location_id || 'No Location'}`
                      })) : []}
                      placeholder="-- Chọn Network SN --"
                      isClearable
                      isSearchable
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>PC SN <span className="text-danger">*</span></Form.Label>
                    <Select
                      value={this.props.pcInfos ? this.props.pcInfos.find(pc => pc.SN === this.state.editFormData.PCSN) ? {
                        value: this.state.editFormData.PCSN,
                        label: `${this.state.editFormData.PCSN} - ${this.props.pcInfos.find(pc => pc.SN === this.state.editFormData.PCSN)?.location_id || 'No Location'}`
                      } : null : null}
                      onChange={(selectedOption) => this.handleEditInputChange('PCSN', selectedOption ? selectedOption.value : '')}
                      options={this.props.pcInfos ? this.props.pcInfos.map(pc => ({
                        value: pc.SN,
                        label: `${pc.SN} - ${pc.location_id || 'No Location'}`
                      })) : []}
                      placeholder="-- Chọn PC SN --"
                      isClearable
                      isSearchable
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.location_id}
                      onChange={(e) => this.handleEditInputChange('location_id', e.target.value)}
                      placeholder="Nhập Location ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="AVAILABLE">Có sẵn</option>
                      <option value="IN USE">Đang sử dụng</option>
                      <option value="NOT WORKING">Không hoạt động</option>
                      <option value="CANCEL">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.description}
                      onChange={(e) => this.handleEditInputChange('description', e.target.value)}
                      placeholder="Nhập mô tả Device Pack"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add Modal */}
        <Modal show={this.state.showAddModal} onHide={this.handleCloseAddModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm Device Pack mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Network SN <span className="text-danger">*</span></Form.Label>
                    <Select
                      value={this.props.networkModems ? this.props.networkModems.find(modem => modem.SN === this.state.newDevicePack.NetworkSN) ? {
                        value: this.state.newDevicePack.NetworkSN,
                        label: `${this.state.newDevicePack.NetworkSN} - ${this.props.networkModems.find(modem => modem.SN === this.state.newDevicePack.NetworkSN)?.location_id || 'No Location'}`
                      } : null : null}
                      onChange={(selectedOption) => this.handleAddInputChange('NetworkSN', selectedOption ? selectedOption.value : '')}
                      options={this.props.networkModems ? this.props.networkModems.map(modem => ({
                        value: modem.SN,
                        label: `${modem.SN} - ${modem.location_id || 'No Location'}`
                      })) : []}
                      placeholder={this.state.loadingDropdowns ? "Đang tải dữ liệu..." : "-- Chọn Network SN --"}
                      isClearable
                      isSearchable
                      isLoading={this.state.loadingDropdowns}
                      isDisabled={this.state.loadingDropdowns}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>PC SN <span className="text-danger">*</span></Form.Label>
                    <Select
                      value={this.props.pcInfos ? this.props.pcInfos.find(pc => pc.SN === this.state.newDevicePack.PCSN) ? {
                        value: this.state.newDevicePack.PCSN,
                        label: `${this.state.newDevicePack.PCSN} - ${this.props.pcInfos.find(pc => pc.SN === this.state.newDevicePack.PCSN)?.location_id || 'No Location'}`
                      } : null : null}
                      onChange={(selectedOption) => this.handleAddInputChange('PCSN', selectedOption ? selectedOption.value : '')}
                      options={this.props.pcInfos ? this.props.pcInfos.map(pc => ({
                        value: pc.SN,
                        label: `${pc.SN} - ${pc.location_id || 'No Location'}`
                      })) : []}
                      placeholder={this.state.loadingDropdowns ? "Đang tải dữ liệu..." : "-- Chọn PC SN --"}
                      isClearable
                      isSearchable
                      isLoading={this.state.loadingDropdowns}
                      isDisabled={this.state.loadingDropdowns}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.newDevicePack.location_id}
                      onChange={(e) => this.handleAddInputChange('location_id', e.target.value)}
                      placeholder="Nhập Location ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.newDevicePack.status}
                      onChange={(e) => this.handleAddInputChange('status', e.target.value)}
                    >
                      <option value="AVAILABLE">Có sẵn</option>
                      <option value="IN USE">Đang sử dụng</option>
                      <option value="NOT WORKING">Không hoạt động</option>
                      <option value="CANCEL">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.newDevicePack.description}
                      onChange={(e) => this.handleAddInputChange('description', e.target.value)}
                      placeholder="Nhập mô tả Device Pack"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.newDevicePack.note}
                      onChange={(e) => this.handleAddInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAddModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveAdd}>
              Lưu
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Network Info Modal */}
        <Modal show={this.state.showNetworkModal} onHide={this.handleCloseNetworkModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Network Modem</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedNetworkInfo && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Serial Number:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNetworkInfo.SN}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Location ID:</strong> 
                    <div className="mt-1">{this.state.selectedNetworkInfo.location_id || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Mô tả vị trí:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedNetworkInfo.location_description || '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Network Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin mạng</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên WiFi:</strong> 
                    <div className="mt-1">{this.state.selectedNetworkInfo.wifi_name || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>Nhà cung cấp:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkInfo.provider ? (
                        <Badge 
                          bg={
                            this.state.selectedNetworkInfo.provider === 'FPT' ? 'primary' :
                            this.state.selectedNetworkInfo.provider === 'VIETTEL' ? 'success' :
                            this.state.selectedNetworkInfo.provider === 'VNPT' ? 'warning' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapProvider(this.state.selectedNetworkInfo.provider)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Financial Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tài chính</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Phí lắp đặt:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkInfo.setup_fee ? (
                        <span className="text-success fw-bold">
                          {this.state.selectedNetworkInfo.setup_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Phí hàng tháng:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkInfo.monthly_fee ? (
                        <span className="text-primary fw-bold">
                          {this.state.selectedNetworkInfo.monthly_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Date Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin ngày tháng</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày bắt đầu:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkInfo.registration_start_date ? 
                        new Date(this.state.selectedNetworkInfo.registration_start_date).toLocaleString('vi-VN', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày hết hạn:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkInfo.expiry_date ? 
                        new Date(this.state.selectedNetworkInfo.expiry_date).toLocaleString('vi-VN', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkInfo.status ? (
                        <Badge 
                          bg={
                            this.state.selectedNetworkInfo.status === 'ACTIVE' ? 'success' :
                            this.state.selectedNetworkInfo.status === 'INACTIVE' ? 'warning' :
                            this.state.selectedNetworkInfo.status === 'CANCEL' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedNetworkInfo.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseNetworkModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* PC Info Modal */}
        <Modal show={this.state.showPCModal} onHide={this.handleClosePCModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin PC</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedPCInfo && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Serial Number:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedPCInfo.SN}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Location ID:</strong> 
                    <div className="mt-1">{this.state.selectedPCInfo.location_id || '-'}</div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Hệ điều hành:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                        {this.state.selectedPCInfo.operating_system || '-'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Dung lượng C:</strong> 
                    <div className="mt-1">{this.state.selectedPCInfo.c_drive_capacity || '-'}</div>
                  </Col>
                </Row>
                
                {/* Ultraview Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin Ultraview</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ultraview ID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.ultraview_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                            {this.state.selectedPCInfo.ultraview_id}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedPCInfo.ultraview_id)}
                            title="Copy Ultraview ID"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ultraview Password:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.ultraview_password ? (
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ wordBreak: 'break-all' }}>
                            {this.state.selectedPCInfo.ultraview_password}
                          </div>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedPCInfo.ultraview_password)}
                            title="Copy Ultraview Password"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* AnyDesk Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin AnyDesk</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>AnyDesk ID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.anydesk_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                            {this.state.selectedPCInfo.anydesk_id}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedPCInfo.anydesk_id)}
                            title="Copy AnyDesk ID"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>AnyDesk Password:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.anydesk_password ? (
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ wordBreak: 'break-all' }}>
                            {this.state.selectedPCInfo.anydesk_password}
                          </div>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedPCInfo.anydesk_password)}
                            title="Copy AnyDesk Password"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Date and Price Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin ngày tháng & Giá</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày cài đặt:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.install_date ? 
                        new Date(this.state.selectedPCInfo.install_date).toLocaleString('vi-VN', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Giá:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.price ? 
                        <span className="text-success fw-bold">
                          {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(this.state.selectedPCInfo.price)}
                        </span> : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.status ? (
                        <Badge 
                          bg={
                            this.state.selectedPCInfo.status === 'ACTIVE' ? 'success' :
                            this.state.selectedPCInfo.status === 'INACTIVE' ? 'warning' :
                            this.state.selectedPCInfo.status === 'CANCEL' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedPCInfo.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClosePCModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    devicePacks: state.tkt1DevicePackReducer.devicePacks,
    totalCount: state.tkt1DevicePackReducer.totalCount,
    networkModems: state.tkt1NetworkModemReducer.networkModems,
    pcInfos: state.tkt1PCInfoReducer.pcInfos
  };
};

export default connect(mapStateToProps, { getTKT1DevicePacks, getTKT1NetworkModems, getTKT1PCInfos, createTKT1DevicePack, updateTKT1DevicePack })(TKT1DevicePack);
